function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.08 7.0001C20.9072 6.70072 20.6598 6.45123 20.3618 6.27597C20.0639 6.10071 19.7256 6.00566 19.38 6.0001H6.58L6 3.7401C5.9414 3.52194 5.81066 3.33004 5.62908 3.19567C5.44749 3.0613 5.22576 2.99236 5 3.0001H3C2.73478 3.0001 2.48043 3.10545 2.29289 3.29299C2.10536 3.48053 2 3.73488 2 4.0001C2 4.26531 2.10536 4.51967 2.29289 4.7072C2.48043 4.89474 2.73478 5.0001 3 5.0001H4.24L7 15.2601C7.0586 15.4783 7.18934 15.6702 7.37092 15.8045C7.55251 15.9389 7.77424 16.0078 8 16.0001H17C17.1847 15.9995 17.3656 15.9479 17.5227 15.8508C17.6798 15.7537 17.8069 15.615 17.89 15.4501L21.17 8.8901C21.3122 8.59211 21.3783 8.26357 21.3626 7.93378C21.3469 7.604 21.2498 7.28323 21.08 7.0001ZM16.38 14.0001H8.76L7.13 8.0001H19.38L16.38 14.0001Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.5 21.0001C8.32843 21.0001 9 20.3285 9 19.5001C9 18.6717 8.32843 18.0001 7.5 18.0001C6.67157 18.0001 6 18.6717 6 19.5001C6 20.3285 6.67157 21.0001 7.5 21.0001Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 21.0001C18.3284 21.0001 19 20.3285 19 19.5001C19 18.6717 18.3284 18.0001 17.5 18.0001C16.6716 18.0001 16 18.6717 16 19.5001C16 20.3285 16.6716 21.0001 17.5 21.0001Z",
  fill: "black"
});

var SvgCart = function SvgCart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cart.8e9486cc.svg";
export { ForwardRef as ReactComponent };